import Vue from 'vue'
import Vuex from 'vuex'
import { formatCoin4 } from '@/tools'

Vue.use(Vuex)

const snakeToCamel = (str) =>
  str.replace(/([-_]\w)/g, (g) => g[1].toUpperCase())

const freezeMonthAll = [720,715,705,690,670,645,615,580,540,495,445,445,360,350,340,330,320,310,300,290,280,270,260,250,180,175,170,165,160,150,140,130,120,110,100,90]
  .map((p, i) => ({ code: Date.UTC(2021,11 + i,1), index: p}))
  .filter(i => i.code >= Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), 1))

export default new Vuex.Store({
  state: {
    package: {},
    packageAll: [],

    freezing: 0,

    startCourse: 5000,
    startCourseAll: [
      { code: 5000, label: '5 000 EUR' },
      { code: 10000, label: '10 000 EUR' },
      { code: 15000, label: '15 000 EUR' },
      { code: 20000, label: '20 000 EUR' },
      { code: 25000, label: '25 000 EUR' },
      { code: 30000, label: '30 000 EUR' },
    ],

    endCourse: 5000,
    endCourseAll: [
      { code: 5000, label: '5 000 EUR' },
      { code: 10000, label: '10 000 EUR' },
      { code: 15000, label: '15 000 EUR' },
      { code: 20000, label: '20 000 EUR' },
      { code: 25000, label: '25 000 EUR' },
      { code: 50000, label: '50 000 EUR' },
      { code: 100000, label: '100 000 EUR' },
    ],

    freezeMonth: freezeMonthAll[0].code,
    freezeMonthAll,

    /** config */
    config: {
      domainUltimaFarm: '',
      domainUltimaRest: '',
      domainWorld: 'https://platinworld.plcu.dev',
      domainWorldRest: 'https://platinworld.plcu.dev/world',
    },

    profile: {
      allowPublicProfile: null,
      avatar: null,
      comment: null,
      firstName: null,
      instagram: null,
      inviteCode: null,
      lastName: null,
      mobile: null,
      position: null,
      skype: null,
      telegram: null,
      userId: null,
      viber: null,
      wechat: null,
      whatsapp: null,
    },
  },
  mutations: {
    setPackage(state, value) {
      state.package = value
    },
    setPackageAll(state, value) {
      state.packageAll = value
      state.package = value[0]
    },

    // StartCourse
    setStartCourse(state, value) {
      state.startCourse = value
    },

    // EndCourse
    setEndCourse(state, value) {
      state.endCourse = value
    },

    // AvailableMaxLoad
    setFreezeMonth(state, value) {
      state.freezeMonth = value
    },

    setFreezing(state, value) {
      state.freezing = value
    },

    /** config */
    setConfig(state, value) {
      Object.keys(value).forEach((key) => {
        state.config[snakeToCamel(key)] = value[key]
      })
    },

    /** profile */
    setProfile(state, value) {
      state.profile = { ...state.profile, ...value}
    },
  },
  getters: {
    license: state => state.package.license,
    licenseAll: state => state.packageAll.map(pack => ({
      code: pack.license,
      label: pack.licenseName,
    })),
    availableMaxLoad: state => formatCoin4(state.package.license / state.startCourse),
    availableMaxLoadAll: state => state.packageAll.map(pack => ({
      code: formatCoin4(pack.license / state.startCourse),
      label: formatCoin4(pack.license / state.startCourse) + ' PLCU',
    })),
    mintingCalendar: state => {
      const freezeMonth = state.freezeMonthAll.find(i => i.code === state.freezeMonth).index
      const year = state.freezing / 100 * freezeMonth
      const month = year / 12
      const day = month / 30
      return {
        year: { PLCU: year.toFixed(4), EUR: (year * state.endCourse).toFixed(2) },
        month: { PLCU: month.toFixed(4), EUR: (month * state.endCourse).toFixed(2) },
        day: { PLCU: day.toFixed(4), EUR: (day * state.endCourse).toFixed(2) },
      }
    },

    /** config */
    getConfig: state => state.config,

    /** profile */
    getProfile: state => state.profile,
  }
})
